const map = {
	"./0/Kambi/SecondaryMenu.layout.js": [
		8017,
		[
			12915,
			73879
		]
	],
	"./0/Poker/SecondaryMenu.layout.js": [
		4131,
		[
			12915,
			71006
		]
	],
	"./0/Spectate/SecondaryMenu.layout.js": [
		33790,
		[
			12915,
			46246
		]
	],
	"./1/Kambi/SecondaryMenu.layout.js": [
		21623,
		[
			11450
		]
	],
	"./1/Poker/SecondaryMenu.layout.js": [
		83330,
		[
			12915,
			47147
		]
	],
	"./1/Spectate/SecondaryMenu.layout.js": [
		97680,
		[
			12915,
			2003
		]
	],
	"./101/Spectate/SecondaryMenu.layout.js": [
		31883,
		[
			12915,
			61542
		]
	],
	"./31/Kambi/SecondaryMenu.layout.js": [
		38185,
		[
			12915,
			44391
		]
	],
	"./31/Poker/SecondaryMenu.layout.js": [
		38342,
		[
			12915,
			40796
		]
	],
	"./31/Spectate/SecondaryMenu.layout.js": [
		78059,
		[
			12915,
			58068
		]
	],
	"./58/Spectate/SecondaryMenu.layout.js": [
		39885,
		[
			12915,
			22719
		]
	],
	"./75/Kambi/SecondaryMenu.layout.js": [
		66881,
		[
			12915,
			46719
		]
	],
	"./75/Spectate/SecondaryMenu.layout.js": [
		97550,
		[
			12915,
			74724
		]
	],
	"./76/Kambi/SecondaryMenu.layout.js": [
		81061,
		[
			12915,
			79108
		]
	],
	"./76/Spectate/SecondaryMenu.layout.js": [
		5089,
		[
			12915,
			63327
		]
	],
	"./8/Poker/SecondaryMenu.layout.js": [
		23323,
		[
			12915,
			88838
		]
	],
	"./8/Spectate/SecondaryMenu.layout.js": [
		65881,
		[
			12915,
			82669,
			13022
		]
	],
	"./81/Kambi/SecondaryMenu.layout.js": [
		68634,
		[
			12915,
			72522
		]
	],
	"./81/Spectate/SecondaryMenu.layout.js": [
		85447,
		[
			12915,
			51845
		]
	],
	"./84/Kambi/SecondaryMenu.layout.js": [
		45614,
		[
			12915,
			34635
		]
	],
	"./84/Spectate/SecondaryMenu.layout.js": [
		16140,
		[
			12915,
			17484
		]
	],
	"./86/Spectate/SecondaryMenu.layout.js": [
		41529,
		[
			12915,
			25290
		]
	],
	"./87/Spectate/SecondaryMenu.layout.js": [
		88894,
		[
			12915,
			58919
		]
	],
	"./88/Spectate/SecondaryMenu.layout.js": [
		93507,
		[
			12915,
			81288
		]
	],
	"./89/Spectate/SecondaryMenu.layout.js": [
		84560,
		[
			12915,
			25290,
			37709
		]
	],
	"./90/Spectate/SecondaryMenu.layout.js": [
		27186,
		[
			12915,
			25290,
			65883
		]
	],
	"./91/Spectate/SecondaryMenu.layout.js": [
		71917,
		[
			12915,
			25290,
			49774
		]
	],
	"./92/Spectate/SecondaryMenu.layout.js": [
		29860,
		[
			12915,
			87253
		]
	],
	"./94/Spectate/SecondaryMenu.layout.js": [
		58521,
		[
			12915,
			68439
		]
	],
	"./95/Spectate/SecondaryMenu.layout.js": [
		71636,
		[
			12915,
			55738
		]
	],
	"./96/Poker/SecondaryMenu.layout.js": [
		91694,
		[
			12915,
			53545
		]
	],
	"./96/Spectate/SecondaryMenu.layout.js": [
		45780,
		[
			12915,
			82669,
			92593
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 21871;
module.exports = webpackAsyncContext;